// Serequímica – site configuration
export const site = {
  brand: "Serequímica",
  tagline: "Indústria e Comércio de Produtos Químicos",
  whatsappRaw: "5563992551989",
  whatsappDisplay: "(63) 99255-1989",
  whatsappMessage:
    "Olá! Vim pelo site da Serequímica e gostaria de falar com um especialista.",
  email: "serequimica@gmail.com",
  socials: {
    instagram: "https://www.instagram.com/serequimica",
    facebook: "https://www.facebook.com/serequimica",
  },
  catalogs: [
    {
      id: "frigorificos",
      title: "Frigoríficos & Abatedouros",
      subtitle: "Higienização profissional em processamento de alimentos",
      description:
        "Detergentes, sanitizantes e desincrustantes desenvolvidos para plantas frigoríficas — segurança sanitária, alto poder de limpeza e conformidade com as exigências do setor.",
      cover: "/assets/frig-1.jpg",
      preview: ["/assets/frig-2.jpg", "/assets/frig-3.jpg"],
      pdf: "/assets/catalogo-frigorificos.pdf",
      badges: ["Alcalino Espumante", "Sanitizante Clorado", "Neutralizante"],
    },
    {
      id: "metalmecanica",
      title: "Metalmecânica",
      subtitle: "Ciência química a serviço da produtividade industrial",
      description:
        "Fluidos de usinagem, desengraxantes industriais, protetivos anticorrosivos e soluções de decapagem para o ciclo produtivo metalmecânico com máxima eficiência de custos.",
      cover: "/assets/metal-1.jpg",
      preview: ["/assets/metal-2.jpg", "/assets/metal-3.jpg"],
      pdf: "/assets/catalogo-metalmecanica.pdf",
      badges: ["Fluido de Usinagem", "Anticorrosivo", "Decapagem"],
    },
    {
      id: "agro",
      title: "Agro & Implementos",
      subtitle: "Alto desempenho no campo, do trator ao pulverizador",
      description:
        "Linha completa para limpeza, proteção e manutenção de implementos agrícolas — tratores, plantadeiras, pulverizadores e colheitadeiras trabalhando mais tempo, com menos parada.",
      cover: "/assets/agro-1.jpg",
      preview: ["/assets/agro-2.jpg", "/assets/agro-3.jpg"],
      pdf: "/assets/catalogo-agro.pdf",
      badges: ["Linha Amazonas", "Óleo Protetivo", "Anti Respingo"],
    },
  ],
  pillars: [
    {
      title: "Alta Performance",
      text: "Fórmulas concentradas testadas em campo, com rendimento superior por litro aplicado.",
    },
    {
      title: "Segurança Operacional",
      text: "Produtos formulados para uso profissional, com fichas técnicas e modo de uso claros.",
    },
    {
      title: "Eficiência Comprovada",
      text: "Menos tempo parado, mais tempo produzindo. Resultado real onde importa.",
    },
    {
      title: "Qualidade Garantida",
      text: "Controle rigoroso lote a lote — o mesmo padrão da primeira à milésima entrega.",
    },
  ],
};

export const waLink = () =>
  `https://wa.me/${site.whatsappRaw}?text=${encodeURIComponent(site.whatsappMessage)}`;
